module.exports = __webpack_public_path__ + "img/cancel_icon.6e6bc795.svg";